/*
 * Copyright (C) 2026 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import {useMemo} from 'react'
import {useScope as createI18nScope} from '@canvas/i18n'
import {BarChart, BarChartDataItem} from './BarChart'

const I18n = createI18nScope('accessibility_checker')

export type IssueStatusBarChartProps = {
  open: number
  resolved: number
}

export const IssueStatusBarChart = (props: IssueStatusBarChartProps) => {
  const open = props.open || 0
  const resolved = props.resolved || 0

  const data = useMemo((): BarChartDataItem[] => {
    return [
      {
        label: I18n.t('%{count} open', {count: I18n.n(open)}),
        emphasized: true,
        value: open,
        color: 'red',
      },
      {
        label: I18n.t('%{count} resolved', {count: I18n.n(resolved)}),
        value: resolved,
        color: 'green',
      },
    ]
  }, [open, resolved])

  return <BarChart title={I18n.t('Issue status')} barThickness={24} data={data} />
}
